// removed by extract-text-webpack-plugin
module.exports = {"wrap":"rate-common-ratioSelect-wrap","wrapInput":"rate-common-ratioSelect-wrapInput","down":"rate-common-ratioSelect-down","unfold":"rate-common-ratioSelect-unfold","wrapUl":"rate-common-ratioSelect-wrapUl","wrapItem":"rate-common-ratioSelect-wrapItem"};


//////////////////
// WEBPACK FOOTER
// ./src/components/rate/common/ratioSelect/index.css
// module id = 1831
// module chunks = 0